import React, { useState } from "react";
import { IconButton, Stack, SwipeableDrawer, Toolbar } from "@mui/material";
import { MenuRounded } from "@mui/icons-material";

const NavDrawer = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setIsOpen(open);
  };

  return (
    <Stack>
      <Toolbar marginHeight={0}>
        <IconButton
          aria-label="open drawer"
          onClick={toggleDrawer(true)}
        >
          <MenuRounded/>
        </IconButton>
      </Toolbar>
      <SwipeableDrawer
        variant="temporary"
        anchor="right"
        open={isOpen}
        onClick={() => setIsOpen(false)}
        ModalProps={{
          keepMounted: false,
        }}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        {children}
      </SwipeableDrawer>
    </Stack>
  );
};

export default NavDrawer;